"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalPaymentChoiceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../../commonFunctions");
var react_router_dom_1 = require("react-router-dom");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var moment = require("moment");
var PremiumChoiceComponent_1 = require("../../../../components/annual/PremiumChoiceComponent");
var AnnualMotorRenewalPaymentChoiceWidget = exports.AnnualMotorRenewalPaymentChoiceWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalPaymentChoiceWidget, _super);
    function AnnualMotorRenewalPaymentChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            var newPremiumType = event.target.value;
            var tieredFactors = _this.props.interaction.tieredFactors || [];
            if (tieredFactors.length > 0) {
                tieredFactors.forEach(function (factors, index) {
                    _this.props.onStateChange("tieredFactors[".concat(index, "].premiumType"), newPremiumType);
                });
            }
            _this.props.onStateChange("factors.premiumType", newPremiumType);
            if (newPremiumType === "annual") {
                _this.setState({
                    paymentOption: "annual"
                });
            }
            else {
                _this.setState({
                    paymentOption: "monthly"
                });
            }
            window.sessionStorage.setItem("renewalChangesModified", "true");
        };
        var paymentOption = _this.props.interaction.factors ? _this.props.interaction.factors.premiumType : undefined;
        _this.state = {
            paymentOption: paymentOption,
            policy: undefined
        };
        return _this;
    }
    AnnualMotorRenewalPaymentChoiceWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.interaction.agreementNumber).subscribe(function (policy) {
            _this.setState({ policy: policy });
        });
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.render = function () {
        var _a;
        if (!((_a = this.state) === null || _a === void 0 ? void 0 : _a.policy)) {
            return React.createElement(components_1.Overlay, { show: true });
        }
        var paymentEligibility = this.props.interaction.polarisPolicyData.instalmentAllowedStatus;
        var monthlyAvailable = paymentEligibility === "A";
        var paymentOption = this.props.interaction.factors ? this.props.interaction.factors.premiumType : undefined;
        return (React.createElement("div", { className: "premium-output no-shadow mb-0" },
            React.createElement("div", { className: "top-section" },
                monthlyAvailable && React.createElement(PremiumChoiceComponent_1.PremiumChoiceComponent, { interaction: this.props.interaction, onChange: this.handleOnChangeEvent }),
                !monthlyAvailable && this.renderAnnualOnly(),
                paymentOption === "monthly" ? this.renderMonthlyPaymentDetails() : monthlyAvailable ? this.renderAnnualPaymentDetails() : React.createElement(React.Fragment, null))));
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.renderMonthlyPaymentDetails = function () {
        var _this = this;
        var _a, _b;
        var numberOfInstalments = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.numberOfInstalments;
        var allInstalmentsHaveSameAmount = new Set(this.props.interaction.paymentDetails.instalmentPlan.instalments.map(function (instalment) { return _this.getInstalmentAmount(instalment); })).size == 1;
        var firstMonthInstalmentPrice = this.props.interaction.paymentDetails.instalmentPlan.instalments.filter(function (inst) { return inst.month == 1; }).map(function (inst) { return _this.getInstalmentAmount(inst); })[0];
        var instalmentPrice = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        var interestRate = this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.interestRate;
        var APR = this.props.interaction.paymentDetails.instalmentPlan.apr;
        var totalAmount = this.props.interaction.paymentDetails.instalmentPlan.totalAmount;
        var creditCost = this.props.interaction.paymentDetails.instalmentPlan.creditCost;
        var premiumType = (_a = this.state.policy) === null || _a === void 0 ? void 0 : _a.interaction.factors.premiumType;
        var monthlyPayerInitialPaymentDate = this.props.interaction.renewalDetails.monthlyPayerInitialPaymentDate || this.props.interaction.renewalDetails.annualPayerInitialPaymentDate;
        return (React.createElement(React.Fragment, null,
            this.renderMonthlyPaymentInfo(),
            React.createElement("table", { className: "payment-choice-table mb-3" },
                this.renderInstalmentAmountRelatedInfo(allInstalmentsHaveSameAmount, numberOfInstalments, instalmentPrice, firstMonthInstalmentPrice),
                React.createElement("tr", null,
                    React.createElement("td", null, "First payment date *"),
                    React.createElement("td", null, moment.utc(monthlyPayerInitialPaymentDate, moment.ISO_8601).format("DD MMM YYYY"))),
                React.createElement("tr", { className: "payment-choice-row-white" },
                    React.createElement("td", null, "Interest rate"),
                    React.createElement("td", null,
                        interestRate,
                        "%")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Credit representative APR"),
                    React.createElement("td", null,
                        APR,
                        "% **")),
                React.createElement("tr", { className: "payment-choice-row-white" },
                    React.createElement("td", null, "Credit cost"),
                    React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(creditCost))),
                React.createElement("tr", { className: "payment-choice-row-blue" },
                    React.createElement("td", null, "Total amount for 1 year"),
                    React.createElement("td", null,
                        React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(totalAmount)))),
                React.createElement("tr", { className: "payment-choice-row-white price-explained-big" },
                    React.createElement("td", { colSpan: 2 },
                        React.createElement("strong", null,
                            "Last year\u2019s price: ",
                            (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.renewalDetails.lastYearsPremium)),
                        "*** ",
                        React.createElement("br", null),
                        premiumType === services_1.PREMIUM_TYPE_MONTHLY &&
                            React.createElement(React.Fragment, null,
                                "You paid ",
                                (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.renewalDetails.lastYearsMonthlyPremium),
                                " / month"))),
                React.createElement("tr", { className: "payment-choice-row-white clarification-row-lg price-explained-extra-big" },
                    React.createElement("td", { colSpan: 2 }, "All figures include Insurance Premium Tax.")),
                React.createElement("tr", { className: "payment-choice-row-white clarification-row price-explained-small" },
                    React.createElement("td", { colSpan: 2 },
                        "* You can change your payment day in the\u00A0",
                        React.createElement(react_router_dom_1.Link, { className: "color-cyan-blue", to: "/dashboard/annualPaymentHistory/".concat((_b = this.state.policy) === null || _b === void 0 ? void 0 : _b.policyNumber) },
                            React.createElement("u", null, "payment section")))),
                React.createElement("tr", { className: "payment-choice-row-white clarification-row price-explained-small" },
                    React.createElement("td", { colSpan: 2 }, "** Credit supplied by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company")),
                React.createElement("tr", { className: "payment-choice-row-white clarification-row price-explained-small" },
                    React.createElement("td", { colSpan: 2 }, "*** Including any changes made")))));
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.renderAnnualPaymentDetails = function () {
        var _a;
        var isRenewalProposal = this.props.interaction.status === services_1.POLICY_STATUS_PENDING_RENEWAL_PENDING_UPDATE;
        var premiumType = (_a = this.state.policy) === null || _a === void 0 ? void 0 : _a.interaction.factors.premiumType;
        return (React.createElement(React.Fragment, null,
            React.createElement("table", { className: "payment-choice-table mb-3" },
                isRenewalProposal &&
                    React.createElement("tr", { className: "payment-choice-row-white" },
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("strong", null,
                                "Last year\u2019s price: ",
                                (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.renewalDetails.lastYearsPremium),
                                "*"),
                            " ",
                            React.createElement("br", null),
                            premiumType === services_1.PREMIUM_TYPE_MONTHLY &&
                                React.createElement(React.Fragment, null,
                                    "You paid ",
                                    (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.renewalDetails.lastYearsMonthlyPremium),
                                    " / month"))),
                isRenewalProposal &&
                    React.createElement("tr", { className: "payment-choice-row-white clarification-row-lg" },
                        React.createElement("td", { colSpan: 2 }, "All figures include Insurance Premium Tax.")),
                isRenewalProposal &&
                    React.createElement("tr", { className: "payment-choice-row-white clarification-row" },
                        React.createElement("td", { colSpan: 2 }, "* Including any changes made")))));
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.renderAnnualOnly = function () {
        var isRenewalProposal = this.props.interaction.status === services_1.POLICY_STATUS_PENDING_RENEWAL_PENDING_UPDATE;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "premium-info-annual-only-top" },
                React.createElement("div", { id: "price", className: "price font-family-display font-weight-bold" },
                    (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.annualPremium),
                    React.createElement("span", { className: "muli-bold-16" }, " / year*")),
                React.createElement("p", { className: "font-weight-bold mb-0 pt-3" }, "Sorry, we can't offer you a monthly plan")),
            React.createElement("div", { className: "premium-info-annual-only-bottom" },
                React.createElement("p", { className: "divider-top" },
                    React.createElement("strong", null,
                        "Last year\u2019s price: ",
                        (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.renewalDetails.lastYearsPremium),
                        "**")),
                React.createElement("p", { className: "mb-1" }, services_1.resourcesHelper.UNDERWRITER),
                isRenewalProposal &&
                    React.createElement("div", null, "* All figures include Insurance Premium Tax."),
                isRenewalProposal &&
                    React.createElement("div", null, "** Including any changes made"))));
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.renderInstalmentAmountRelatedInfo = function (allInstalmentsHaveSameAmount, numberOfInstalments, instalmentPrice, firstMonthInstalmentPrice) {
        if (allInstalmentsHaveSameAmount) {
            return (React.createElement("tr", null,
                React.createElement("td", null,
                    numberOfInstalments,
                    " payments of"),
                React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(instalmentPrice))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("tr", null,
                    React.createElement("td", null, "First payment of"),
                    React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(firstMonthInstalmentPrice))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        numberOfInstalments - 1,
                        " further payments of"),
                    React.createElement("td", null, (0, commonFunctions_1.getAmountToDisplay)(instalmentPrice)))));
        }
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.renderMonthlyPaymentInfo = function () {
        return (React.createElement("div", { className: "banner banner-info" },
            React.createElement("p", { className: "mb-0" },
                "The cost of your insurance and the interest charged is spread over the year, so paying for your insurance ",
                React.createElement("span", { className: "font-weight-bold" }, "monthly will cost more than if you paid annually"),
                ". Please check you can afford the monthly payments.")));
    };
    AnnualMotorRenewalPaymentChoiceWidget.prototype.getInstalmentAmount = function (instalment) {
        return (instalment.principal + instalment.interest).toFixed(2);
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorRenewalPaymentChoiceWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorRenewalPaymentChoiceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualMotorRenewalPaymentChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/AnnualMotorRenewalPaymentChoiceWidget.js
// module id = 3186
// module chunks = 0